const condition = ({ to: { path } }) => /\/logout/.test(path);
const whenTrue = ({ next }) => localStorage.clear() & next("/acesso/login");

export default [condition, whenTrue];
